import { Injectable } from "@angular/core";
import { RestService } from "../communication-rest/communication-rest.service";
import { urlServicesGlobalCat } from "../../constants/global-cat.constants";
import { ResponseDto } from "../../models/generic/response.dto";
import { Observable, map } from "rxjs";
import { LanguageDto } from "../../models/catalog/language.dto";
@Injectable({
    providedIn: 'root'
})
export class CatLanguageService {
    constructor(protected restService: RestService){
    }

    //languages/all
    getLanguages(): Observable<LanguageDto[]>{        
        return this.restService.get<ResponseDto>(urlServicesGlobalCat.catLanguages, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', true);
                })
            );
    }

    //languages/ids/{languageId}
    getLanguage(languageId : string): Observable<LanguageDto>{
        return this.restService.get<ResponseDto>(urlServicesGlobalCat.catLanguage.concat(languageId), true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, '', false);
                })
            );
    }

}